import { Navigate, Outlet } from 'react-router-dom';
import { useIsStaff } from '../../hooks/use-is-staff';
import { useFirmContext } from '../../providers/FirmProvider';

/**
Checks if the user is a staff member and redirects them to the firm dashboard page if they are not.
*/
function CimplicoStaffRoute(): JSX.Element {
    const { shortId } = useFirmContext();
    const isStaff = useIsStaff();

    if (!isStaff) {
        return <Navigate to={`/${shortId}`} replace />;
    }

    return <Outlet />;
}

export default CimplicoStaffRoute;
